<template>
  <div
    v-intersect-on.once="{ rootMargin: '150px 0px' }"
    @intersect="getWidgetData"
  >
    <div v-if="!isFirstOpen">
      <a
        v-if="service"
        :href="serviceLink"
        target="_blank"
        rel="noopener"
      >
        <ServiceWidgetItem :service="service" />
      </a>
      <!-- no_image_item.png の変更時には画像の修正が必要(画像がno_image_itemを元に作られているため) -->
      <img
        v-else
        src="@/assets/images/components/BlogService/unexist_service.png"
        loading="lazy"
        decoding="async"
      />
    </div>
    <a
      class="c-blogService_loading"
      v-else
      :href="`/services/${id}`"
      target="_blank"
      rel="noopener"
    >
      {{ dummyLinkText }}
      <BLoading
        active
        :is-full-page="false"
      />
    </a>
  </div>
</template>
<script>
import ServiceWidgetItem from '../components/ServiceWidgetItem'

export default {
  name: 'BlogService',
  components: {
    ServiceWidgetItem
  },
  props: {
    // DOM生成して渡すためStringで定義
    id: {
      type: String
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      service: null,
      isFirstOpen: true
    }
  },
  computed: {
    serviceLink() {
      const params = {}
      params.ref = 'blog'
      return this.$coconala.rootPathUrl(`/services/${this.id}`, params)
    },
    // ダミー用のリンク文言でタイトルがあればタイトルを表示/なければURLを表示
    dummyLinkText() {
      return this.title ? this.title : this.$coconala.getCurrentURL(`/services/${this.id}`, {})
    }
  },
  methods: {
    async getWidgetData() {
      try {
        const response = await this.$store.dispatch('pages/blogs/widget/fetchWidgetServices', [
          Number(this.id)
        ])
        // Map型をgrpcで取得する場合、grpc-webだとArrayで返ってきてしまうためデータを加工する
        const serviceWidgets = {}
        response.serviceWidgetsMap.forEach(serviceWidget => {
          const key = serviceWidget[0]
          const value = serviceWidget[1]
          serviceWidgets[key] = value
        })

        // サービスが見つかる場合のみwidgetを表示する
        if (serviceWidgets[Number(this.id)]) {
          this.service = serviceWidgets[Number(this.id)]
        }
      } catch {
        // エラーになった場合はブランク画像のウィジェットを表示するため無視する
      }
      this.isFirstOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-blogService {
  &_loading {
    position: relative;
    display: block;
    padding: 16px;
    height: 304px;
    border: 1px solid $color-gray-200;
  }
}
</style>
